import React from 'react';
import classNames from 'classnames';
import { useChowaTheme } from './chowaThemeContext';

const ChowaTable = ({ columns, data, renderMobileRow, tableColor }) => {
  const { isDark, getCurrentTheme, currentThemeName } = useChowaTheme();

  const currentTheme = getCurrentTheme();

  const colorStyles = {
    blue: {
      border: { light: 'border-blue-500', dark: 'border-blue-400' },
      headerBg: { light: 'bg-blue-100', dark: 'dark:bg-blue-900/50' },
      divider: { light: 'divide-blue-200', dark: 'dark:divide-blue-800' }
    },
    orange: {
      border: { light: 'border-orange-500', dark: 'border-orange-400' },
      headerBg: { light: 'bg-orange-100', dark: 'dark:bg-orange-900/50' },
      divider: { light: 'divide-orange-200', dark: 'dark:divide-orange-800' }
    },
    purple: {
      border: { light: 'border-purple-500', dark: 'border-purple-400' },
      headerBg: { light: 'bg-purple-100', dark: 'dark:bg-purple-900/50' },
      divider: { light: 'divide-purple-200', dark: 'dark:divide-purple-800' }
    },
    gray: {
      border: { light: 'border-gray-500', dark: 'border-gray-400' },
      headerBg: { light: 'bg-gray-100', dark: 'dark:bg-gray-900/50' },
      divider: { light: 'divide-gray-200', dark: 'dark:divide-gray-800' }
    },
  };

  const themeMode = isDark ? 'dark' : 'light';
  const selectedColor = colorStyles[tableColor || currentThemeName] ?? colorStyles.gray;

  const borderColorClass = selectedColor.border?.[themeMode] ?? 'border-gray-200 dark:border-gray-700';
  const headerBgClass = selectedColor.headerBg?.[themeMode] ?? 'bg-gray-100 dark:bg-gray-700/50';
  const dividerColorClass = selectedColor.divider?.[themeMode] ?? 'divide-gray-200 dark:divide-gray-700';

  const defaultMobileRow = (item) => (
    <div className="space-y-1 text-sm">
      {columns.map(col => (
        <div key={col.accessor} className="flex justify-between">
          <span className="font-semibold text-gray-800 dark:text-gray-100">{col.header}:</span>
          <span className="text-gray-600 dark:text-gray-300">{col.cell ? col.cell(item) : item[col.accessor]}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div 
      className={classNames(
        "w-full bg-white dark:bg-gray-800 rounded-lg border overflow-hidden h-full flex flex-col",
        borderColorClass
      )}
      style={{ borderWidth: '2px' }}
    >
      {/* --- テーブルヘッダー (md以上で表示) --- */}
      <div 
        className={classNames(
          "hidden md:grid gap-4 px-4 py-3 flex-shrink-0",
          headerBgClass
        )} 
        style={{ 
          gridTemplateColumns: `repeat(${columns.length}, minmax(0, 1fr))`
        }}
      >
        {columns.map(col => (
          <p key={col.accessor} className="font-semibold text-sm text-gray-800 dark:text-gray-100 text-center">{col.header}</p>
        ))}
      </div>

      {/* --- データエリア --- */}
      <div className={classNames(
        "divide-y flex-grow flex flex-col",
        dividerColorClass
      )}>
        {data.map((item, index) => (
          <div key={index} className="px-4 py-3 flex-grow flex items-center">
            {/* --- PC/タブレット表示 (md以上) --- */}
            <div className="hidden md:grid gap-4 items-center text-sm text-gray-600 dark:text-gray-300 w-full" style={{ gridTemplateColumns: `repeat(${columns.length}, minmax(0, 1fr))` }}>
              {columns.map(col => (
                <div key={col.accessor} className="text-center">
                  {col.cell ? col.cell(item) : item[col.accessor]}
                </div>
              ))}
            </div>

            {/* --- モバイル表示 (md未満) --- */}
            <div className="md:hidden w-full">
              {renderMobileRow ? renderMobileRow(item) : defaultMobileRow(item)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChowaTable; 